import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
const stats = [{
  icon: UsersIcon,
  label: '+500 profes confían'
}, {
  icon: BookOpenIcon,
  label: '12 Tomos + 6 Bonus'
}, {
  icon: StarIcon,
  label: '4.9/5 calificación'
}, {
  icon: MapPinIcon,
  label: '🇦🇷 Argentina'
}];
export function StatBadges() {
  return <section className="py-12 px-4 bg-surface-light" data-id="element-231">
      <div className="max-w-6xl mx-auto" data-id="element-232">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-233">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border border-gray-200 rounded-lg p-6 text-center shadow-sm" data-id="element-234">
              <stat.icon className="w-8 h-8 mx-auto mb-3 text-primary" data-id="element-235" />
              <p className="text-sm font-semibold text-gray-800" data-id="element-236">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}